import React from 'react';
import { ThemeProvider as EmotionThemeProvider } from '@emotion/react';
import { theme as defaultTheme } from '../theme';
import GlobalStyles from './GlobalStyles';

var ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children,
      theme = _ref.theme;
  return /*#__PURE__*/React.createElement(EmotionThemeProvider, {
    theme: theme || defaultTheme
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GlobalStyles, null), children));
};

export default ThemeProvider;